<template>
  <el-dialog
    title="自建作业"
    :visible.sync="dialogVisible"
    width="60%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="作业名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入作业名称"
          @keyup.enter="handleSubmit"
        ></el-input>
      </el-form-item>

      <el-form-item label="作业描述" prop="description">
        <el-input
          type="textarea"
          v-model="form.description"
          :rows="4"
          placeholder="请输入作业描述"
        ></el-input>
      </el-form-item>

      <el-form-item label="截止时间" prop="deadline">
        <el-date-picker
          v-model="form.deadline"
          type="datetime"
          placeholder="选择截止时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="选择班级" prop="selectedClasses">
        <el-select
          v-model="form.selectedClasses"
          multiple
          placeholder="请选择要发布的班级"
          style="width: 100%"
        >
          <el-option
            v-for="classItem in availableClasses"
            :key="classItem.id"
            :label="classItem.gradeName"
            :value="classItem.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImageHomeworkCreator',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      form: {
        name: '',
        description: '',
        deadline: '',
        selectedClasses: []
      },
      rules: {
        name: [
          { required: true, message: '请输入作业名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入作业描述', trigger: 'blur' }
        ],
        deadline: [
          { required: true, message: '请选择截止时间', trigger: 'change' }
        ],
        selectedClasses: [
          { required: true, message: '请选择要发布的班级', trigger: 'change' }
        ]
      },
      availableClasses: []
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.loadAvailableClasses()
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    // 加载可选班级列表
    async loadAvailableClasses() {
      try {
        // 这里应该调用实际的API获取班级列表
        // 暂时使用模拟数据
        this.availableClasses = [
          { id: 1, gradeName: '计算机科学与技术1班' },
          { id: 2, gradeName: '软件工程1班' },
          { id: 3, gradeName: '数据科学与大数据技术1班' }
        ]
      } catch (error) {
        console.error('加载班级列表失败:', error)
        this.$message.error('加载班级列表失败')
      }
    },

    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            // 这里应该调用实际的API创建作业
            console.log('创建作业:', this.form)

            // 模拟API调用
            await new Promise(resolve => setTimeout(resolve, 1000))

            this.$message.success('作业创建成功')
            this.$emit('success', this.form)
            this.handleClose()
          } catch (error) {
            console.error('创建作业失败:', error)
            this.$message.error('创建作业失败')
          } finally {
            this.submitting = false
          }
        }
      })
    },

    // 关闭对话框
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    // 重置表单
    resetForm() {
      this.form = {
        name: '',
        description: '',
        deadline: '',
        selectedClasses: []
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 20px;
}
</style>
